import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  FormControl,
  TextField,
  InputAdornment,
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import EquipTable from "./EquipTable";

export default function EquipmentListTables(props) {
  // const [order, setOrder] = React.useState("asc");
  // const [orderBy, setOrderBy] = React.useState("calories");
  const [rows, setRows] = React.useState([]);
  const [visibleRows, setVisibleRows] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [filterEquipValue, setFilterEquipValue] = React.useState("");

  useEffect(() => {
    const fetchData = () => {
      if (props.selectedEquipment && props.selectedEquipment.length > 0) {
        setSelectedRows(
          props.selectedEquipment.sort((a, b) => a.Name.localeCompare(b.Name)),
        );
        const filteredRows = props.equip
          .filter((item) => !props.selectedEquipment.includes(item))
          .sort((a, b) => a.Name.localeCompare(b.Name));
        setRows(filteredRows);
        setVisibleRows(filteredRows);
      } else {
        setRows(props.equip.sort((a, b) => a.Name.localeCompare(b.Name)));
        setVisibleRows(
          props.equip.sort((a, b) => a.Name.localeCompare(b.Name)),
        );
      }
      setIsLoading(false);
    };

    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  });

  const handleClick = (event, id, tableName) => {
    if (tableName === "Available Equipment") {
      const selectedItem = rows.find((item) => item.id === id);
      const rowss = rows.filter((item) => item.id !== id);
      const visibleRowss = visibleRows.filter((item) => item.id !== id);
      setRows([...rowss]);
      setVisibleRows([...visibleRowss]);
      setSelectedRows([...selectedRows, selectedItem]);
      props.saveSelectedEquip([...selectedRows, selectedItem]);
    } else if (tableName === "Selected Equipment") {
      const selectedItem = selectedRows.find((item) => item.id === id);
      setRows([...rows, selectedItem]);
      setVisibleRows([...visibleRows, selectedItem]);
      const newSelectedRows = selectedRows.filter((item) => item.id !== id);
      setSelectedRows(newSelectedRows);
      props.saveSelectedEquip(newSelectedRows);
    }
  };

  const onAddAllEquip = () => {
    setSelectedRows([...selectedRows, ...visibleRows]);
    props.saveSelectedEquip([...selectedRows, ...visibleRows]);
    setRows(rows.filter((item) => !visibleRows.includes(item)));
    setVisibleRows([]);
  };

  const onRemoveAllEquip = () => {
    setRows([...rows, ...selectedRows]);
    setVisibleRows([...visibleRows, ...selectedRows]);
    setSelectedRows([]);
    props.saveSelectedEquip([]);
  };

  const onFilterEquipChange = (searchTerm) => {
    if (searchTerm.length > 2) {
      const filteredData = rows.filter((obj) => {
        const values = Object.values(obj);
        return values.some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase()),
        );
      });

      setVisibleRows([...filteredData]);
    } else {
      setVisibleRows([...rows]);
    }
    setFilterEquipValue(searchTerm);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box sx={{ width: "100%" }}>
          <Stack
            padding={2}
            direction="row"
            spacing={0}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControl>
              <TextField
                id="outlined-search"
                label="Search Equipment"
                type="search"
                size="small"
                fullWidth
                value={filterEquipValue}
                onChange={(e) => onFilterEquipChange(e.target.value)}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment:
                      props.filterValue && props.filterValue.length > 0 ? (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={"Clear Search"}
                            onClick={props.handleClearSearch}
                            edge="end"
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                  },
                }}
              />
            </FormControl>
            <Button
              disabled={visibleRows.length === 0}
              variant="outlined"
              onClick={onAddAllEquip}
            >
              Add all
            </Button>
          </Stack>

          <Paper sx={{ width: "100%", mb: 2 }}>
            <EquipTable
              arry={visibleRows}
              handleClick={handleClick}
              tableName="Available Equipment"
            />
          </Paper>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Stack
          padding={2}
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Selected Assets</Typography>
          <Button
            disabled={selectedRows.length === 0}
            variant="outlined"
            onClick={onRemoveAllEquip}
          >
            Remove all
          </Button>
        </Stack>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <EquipTable
            arry={selectedRows}
            handleClick={handleClick}
            tableName="Selected Equipment"
          />
        </Paper>
      </Grid>
    </Grid>
  );
}
